/**
 * Used to identify which style to apply to the CharmControl
 */
export enum CharmControlColorPattern {
    Normal = 1,
    TextColor = 2,
    Dark = 3,
}

export default CharmControlColorPattern;
